import { componentName, SwitchToggleClass } from './SwitchToggleClass';
import '@vaadin/checkbox';
import '@vaadin/text-field';
import '@descope-ui/descope-enriched-text';
import '../descope-boolean-field-internal';

customElements.define(componentName, SwitchToggleClass);

export { SwitchToggleClass, componentName };
